import styled from 'styled-components';

export const BrazeContentCardWrapper = styled('div')`
  .braze-content-card {
    margin-top: ${({ theme }) => theme.x1spacePx}px;
    margin-bottom: -${({ theme }) => theme.x1spacePx}px;
  }
`;
